/**
 * @desc 通过线下销售订单号获取详情-线下销售单界面
 */
const URL = "/rantion-business";
import http, { updateResponse } from "@/http";
export function request(boOrderNo: string, options?: any) {
  return updateResponse(
    http(URL + `/customerOrder/getDetailByBoNo/${boOrderNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
